import React from "react"
import PropTypes from "prop-types"

import { InternalRHSCustomTeaser } from "./style"

const InternalRHSTeaser = data => {
  return (
    <InternalRHSCustomTeaser
      title={data.data && data.data.page.title}
      excerpt={data.data && data.data.page.excerpt}
      img={data.data && data.data.page.featuredImage}
      link={data.data && data.data.page.link}
      innerLinkText="Read more"
    ></InternalRHSCustomTeaser>
  )
}

export default InternalRHSTeaser

InternalRHSTeaser.defaultProps = {
  title: "Skilled and business migration",
  excerpt:
    "We provide a wealth of information on business, innovation and investment visas.",
  label: "Read More",
  link: "/",
}

InternalRHSTeaser.propTypes = {
  title: PropTypes.string,
  excerpt: PropTypes.string,
  links: PropTypes.string,
  label: PropTypes.string,
}
